(function () {
  'use strict';

  document.querySelectorAll('[id^="ag-announcement-"]').forEach(function (section) {
    var mode = section.getAttribute('data-mode');
    var speed = parseInt(section.getAttribute('data-speed'), 10) || 5;

    if (mode === 'marquee') {
      initMarquee(section, speed);
    } else {
      initSlider(section, speed);
    }
  });

  function initMarquee(section, speed) {
    var track = section.querySelector('.ag-announcement__track');
    if (!track) return;

    var group = track.querySelector('.ag-announcement__group');
    if (!group) return;

    // Force layout calculation
    var groupWidth = group.getBoundingClientRect().width;
    
    // Safety check if element is hidden or not rendered
    if (groupWidth === 0) return;

    // Calculate required width: Viewport + Scroll Distance (one group) + Buffer
    // We ensure we have enough content to cover the screen even after shifting by one group width.
    var requiredWidth = window.innerWidth + groupWidth;
    var currentWidth = groupWidth;

    // Always clone at least once for the basic loop logic
    var clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
    currentWidth += groupWidth;

    // Continue cloning until we cover the required width
    while (currentWidth < requiredWidth) {
      var extraClone = group.cloneNode(true);
      extraClone.setAttribute('aria-hidden', 'true');
      track.appendChild(extraClone);
      currentWidth += groupWidth;
    }

    var duration = speed * 4;

    requestAnimationFrame(function () {
      track.style.setProperty('--ag-announcement-offset', '-' + groupWidth + 'px');
      track.style.setProperty('--ag-announcement-duration', duration + 's');
      track.classList.add('ag-announcement__track--running');
    });
    
    // Simple resize handler to ensure we still have enough content if window grows
    // Debounced ideally, but simple check is okay here
    window.addEventListener('resize', function() {
        if (window.innerWidth + groupWidth > currentWidth) {
             var needed = (window.innerWidth + groupWidth) - currentWidth;
             while (needed > 0) {
                var newClone = group.cloneNode(true);
                newClone.setAttribute('aria-hidden', 'true');
                track.appendChild(newClone);
                currentWidth += groupWidth;
                needed -= groupWidth;
             }
        }
    }, { passive: true });
  }

  function initSlider(section, speed) {
    var slides = section.querySelectorAll('.ag-announcement__slide');
    if (slides.length < 2) return;

    var prevBtn = section.querySelector('.ag-announcement__arrow--prev');
    var nextBtn = section.querySelector('.ag-announcement__arrow--next');
    var current = 0;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('ag-announcement__slide--active');
      slides[current].setAttribute('aria-hidden', 'true');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('ag-announcement__slide--active');
      slides[current].removeAttribute('aria-hidden');
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      timer = setInterval(next, speed * 1000);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  }
})();
